export default __webpack_public_path__ + "static/big-reflection-512x512.min-5fdf4b3d4a06862bfc94d1e1526814f0.png";